import React from "react";

const SubmitOTP = ({setLoginState, errors, setErrors,formState}) => {
  return (
    <>
      <div className="form-group mb-3">
        <div className="d-flex justify-content-between mt-n5">
          <label className="custom-label-style">
            OTP <span style={{ color: "red" }}>*</span>
          </label>
        </div>
        <input
          id="otp"
          value={formState?.otp}
          className={errors?.otp ? "form-control invalid" : "form-control"}
          type="text"
          name="otp"
          autoComplete="new-password"
          onChange={(e) => {
            setLoginState({
              ...formState,
              userPassword: e.target.value,
              otp: e.target.value,
            });
            setErrors({
              ...errors,
              otp: e.target.value
                ? e.target.value.match(/^\d{6}$/)
                  ? ""
                  : "Invalid OTP"
                : "OTP is Mandatory",
            });
          }}
        />
        <p className="text-danger text-left font-size-xs">
          {errors?.otp && (
            <small className="validation-errors d-block font-size-xs mt-1">
              {errors?.otp}
            </small>
          )}
        </p>
      </div>
    </>
  );
};

export default SubmitOTP;
